export default {
  sections: {
    payment: 'Pagamento',
  },
  labels: {
    proceed_to_payment: 'Procedi al pagamento tramite link o scansiona il codice QR',
  },
  buttons: {
    generate_new_link: 'Genera nuovo link',
    copy_link: 'Copia link',
    pay_now: 'Paga ora',
  },
  toasts: {
    failed_to_create_payment_link: 'Impossibile caricare il link di pagamento',
  },
};
